import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_SUPABASE_URL: z.url(),
    VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
    VITE_PROJECT_NAME: z.string().min(1),
    VITE_CUSTOMER_NAME: z.string().min(1),
  },
  runtimeEnv: import.meta.env,
});
